import { Grid, Group, SimpleGrid, Text, ThemeIcon } from "@mantine/core";
import { IconTarget } from "@tabler/icons-react";
import { getSubIndustryLabel } from "@/components/shared/constants/general.const";
import type { SectorEcosystemOverview } from "../../../../../../shared/sectorEcosystemOverview";
import type { SectorListFooterLink } from "../sectorCompaniesList.const";
import { getStaticSectorOpportunitySubIndustries } from "../sectorEcosystem.const";
import SectorDashboardCard from "./SectorDashboardCard";

type SectorOpportunitiesCardProps = {
  overview: SectorEcosystemOverview;
} & SectorListFooterLink;

export default function SectorOpportunitiesCard({ overview, footerTo, footerLinkState }: SectorOpportunitiesCardProps) {
  const opportunityRows =
    overview.opportunities.length > 0
      ? overview.opportunities.map((row) => row.subIndustry)
      : getStaticSectorOpportunitySubIndustries(overview.slug);

  const opportunitiesListReady = overview.opportunities.length > 0;

  return (
    <SectorDashboardCard
      fillHeight={false}
      title="Opportunities"
      subtitle="What companies are looking for."
      footerLabel="View All Opportunities"
      footerComingSoon={!opportunitiesListReady}
      footerTo={opportunitiesListReady ? footerTo : undefined}
      footerLinkState={opportunitiesListReady ? footerLinkState : undefined}
    >
      <Grid>
        <Grid.Col span={12}>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
      {opportunityRows.map((subIndustry) => (
        <Group key={subIndustry} gap="xs" wrap="wrap">
          <ThemeIcon size={24} radius="md" variant="light" color="blue">
            <IconTarget size={12} />
          </ThemeIcon>
          <Text size="sm" truncate>
            {getSubIndustryLabel(subIndustry)}
          </Text>
        </Group>
      ))}
    </SimpleGrid>
    </Grid.Col>
      </Grid> 
    </SectorDashboardCard>
  );
}
